import { SpaceProps } from '@televet/kibble-ui';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';

const FieldTitleComponent = ({
  fieldTitleText,
  isRequired = true,
  ...rest
}: {
  fieldTitleText: string;
  isRequired?: boolean;
} & SpaceProps): JSX.Element => {
  return (
    <Text size="sm" {...rest}>
      {fieldTitleText}
      {isRequired && (
        <Text variant="danger" ml="2">
          *
        </Text>
      )}
    </Text>
  );
};

export default FieldTitleComponent;
